<input
  type="time"
  [value]="value ?? ''"
  [disabled]="disabled"
  [attr.min]="min"
  [attr.max]="max"
  [attr.step]="step"
  [attr.required]="required ? true : null"
  (input)="onInput($event)"
  (focus)="onFocus()"
  (blur)="onBlur()"
  class="w-full h-full bg-transparent border-0 text-base font-medium text-midnight focus:outline-none"
/>
